import _ from 'lodash'

import {
  ADDRESS_PROPERTY_TYPE_ENUM,
  BILLING_ADDRESS_LEGAL_PERSON_TYPE_ENUM,
  BILLING_ADDRESS_BRANCH_TYPE_ENUM,
} from '@24slg/database-schemas/enums'

export const categories = [
  {
    _id: '633570fd412025001cc50fd8',
    name: 'งานแอร์',
    url: 'air-conditioner',
    code: 'AC',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_3eecca310a.jpg',
    },
    id: '633570fd412025001cc50fd8',
  },
  {
    _id: '633d00325abbcb001c862b2a',
    url: 'washing-machine',
    code: 'WASHING',
    name: 'งานเครื่องซักผ้า',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/shutterstock_1562454151_02_min_d80cc7f3fd.jpg',
    },
    id: '633d00325abbcb001c862b2a',
  },
  {
    name: 'งานไฟฟ้า',
    url: 'electrical',
    code: 'ELE',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_1245a9516f.jpg',
    },
    id: '633570fd412025001cc50fdc',
  },
  {
    name: 'งานประปาและห้องน้ำ',
    url: 'piping',
    code: 'PLUMB',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_e16aabaf47.jpg',
    },
    id: '633570fd412025001cc50fd9',
  },
  {
    url: 'tile',
    name: 'งานกระเบื้อง',
    code: 'TILE',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_8721f7053a.jpg',
    },
    id: '633570fd412025001cc50fd7',
  },
  {
    name: 'งานพื้น',
    url: 'floor',
    code: 'FLOOR',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_065a858550.jpg',
    },
    id: '633570fd412025001cc50fdf',
  },
  {
    name: 'งานผนัง',
    url: 'wall',
    code: 'WALL',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_USP_01_3e0876e0e6.jpg',
    },
    id: '63878547dda467001cc0c8b1',
  },
  {
    name: 'งานทาสี',
    url: 'color',
    code: 'PNT',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_9138779e9d.jpg',
    },
    id: '633570fd412025001cc50fde',
  },
  {
    name: 'งานฝ้าและเพดาน',
    url: 'ceiling',
    code: 'CEIL',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_a2780e51a6.jpg',
    },
    id: '633570fd412025001cc50fda',
  },
  {
    name: 'งานหลังคาและดาดฟ้า',
    url: 'roof',
    code: 'ROOF',
    image: {
      url: 'https://d2jl6hozakvcbj.cloudfront.net/_31e4d7ab12.jpg',
    },
    id: '633570fd412025001cc50fdb',
  },
]

export const addressPropertyTypes = [
  {
    label: 'บ้าน',
    value: ADDRESS_PROPERTY_TYPE_ENUM.HOUSE,
  },
  {
    label: 'บ้านแฝด',
    value: ADDRESS_PROPERTY_TYPE_ENUM.SEMI_DETACHED_HOUSE,
  },
  {
    label: 'ทาวน์เฮาส์/ทาวน์โฮม',
    value: ADDRESS_PROPERTY_TYPE_ENUM.TOWNHOUSE_TOWNHOME,
  },
  {
    label: 'คอนโดมิเนียม',
    value: ADDRESS_PROPERTY_TYPE_ENUM.CONDOMINIUM,
  },
  {
    label: 'อพาร์ทเม้นท์/หอพัก',
    value: ADDRESS_PROPERTY_TYPE_ENUM.APARTMENT_DORMITORY,
  },
  {
    label: 'ห้างสรรพสินค้า',
    value: ADDRESS_PROPERTY_TYPE_ENUM.DEPARTMENT_STORE,
  },
  {
    label: 'อาคารสำนักงาน',
    value: ADDRESS_PROPERTY_TYPE_ENUM.OFFICE_BUILDING,
  },
  {
    label: 'อาคารพาณิชย์',
    value: ADDRESS_PROPERTY_TYPE_ENUM.COMMERCIAL_BUILDING,
  },
]

export const findAddressPropertyType = value => {
  return _.find(addressPropertyTypes, addressPropertyType => {
    return addressPropertyType.value === value
  })
}

export const billingAddressLegalPersonTypes = [
  {
    label: 'บุคคลธรรมดา',
    value: BILLING_ADDRESS_LEGAL_PERSON_TYPE_ENUM.ORDINARY_PERSON,
  },
  {
    label: 'นิติบุคคล',
    value: BILLING_ADDRESS_LEGAL_PERSON_TYPE_ENUM.JURISTIC_PERSON,
  },
]

export const billingAddressBranchTypes = [
  {
    label: 'สำนักงานใหญ่',
    value: BILLING_ADDRESS_BRANCH_TYPE_ENUM.HEAD_OFFICE,
  },
  {
    label: 'สาขา',
    value: BILLING_ADDRESS_BRANCH_TYPE_ENUM.BRANCH,
  },
  {
    label: 'ไม่มี',
    value: BILLING_ADDRESS_BRANCH_TYPE_ENUM.NONE,
  },
]

export const global = {
  phoneOffice: '02-028-2224',
  addressOffice:
    '419 ถนนเอกมัย แขวง คลองตันเหนือ เขตวัฒนา กรุงเทพมหานคร 10110',
  copyright: 'All Rights Reserved Copyright © 2022 24 SOLUTION GROUP (THAILAND) CO., LTD.',
}
